import React, { useEffect, useState } from "react";
import styles from "./scss/leftsidebar.module.scss";
import MeetingsLists from "./meetinglists";
import { Link, useHistory } from 'react-router-dom';
import CreateDropDown from "../../chat/leftsidebar/createdropdown";
import { URInput } from "../../../shared/widgets/input";
import { useSelector } from "react-redux";
import { getMeetingLists } from "../../../base/meetingService/apiService";
import { storeMeetingList, storeWindowState } from "../../../base/meetingService/meetingStoreServices";
import _ from "lodash";
import NotificationBottom from "../../chat/chatWidgets/notificationBottom";
import { chats, contacts, initialStateModel, UserDetails } from "../../../models/model";
import store from "../../../context/store/store";
import { enablePermission, enablePermissionSafari } from "../../../base/utils";
import { chatSideWindow } from "../../../base/eventService/eventApiService";
import recordVid from "../../../styles/images/recordedRed.svg";
import { URButton } from "../../../shared/widgets/button";
import { Button, Modal } from "antd";
import { createPlayList } from "../../../base/callService/common";
// import RecordPlayListsideBars from "../meetingWidgets/recordPlayList";
import PlayLists from "./playList";
import { Types } from "../../../context/action/action";
export default function MeetingsLeftsideBars() {
  let { meetingReducer }: any = useSelector((state: any) => state);
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const contactList: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  //const chat_reducer: chats = store.getState().chatReducer;
  let { getListInput,currentWindowState,recCount } = meetingReducer;
  let history = useHistory();
  const [playlistModal,setPlaylistModal] = useState(false)
  // const [getFilterKey, setFilterKey] = useState("All");
  const [getFilterKeyDisplay, setFilterKeyDisplay] = useState("Upcoming");
  const [getSearchKey, setSearchKey] = useState("");
  const [title,setTitle] = useState("");
  const [description,setDescription] = useState("");
  const selectMeetingFilterKey = (val: any) => {
    storeWindowState("mainPage");//removed one
    history.push("/meeting");
    // setFilterKey(filter);
    setFilterKeyDisplay(val);
    storeMeetingList([]);
    let data: any = {};
    data.offset = 0;
    data.limit = 10;
    data.filter = val;
    data.searchText = getListInput.searchText;
    data.sort = val === "Previous" ? "-1" : "1";
    getMeetingLists(data);
  };
  chat_reducer.isWindowSlide && chatSideWindow(false, "", {});
  // const sortMeeting = () => {
  //   storeMeetingList([]);
  //   let data: any = {};
  //   data.offset = 0;
  //   data.limit = getListInput.limit;
  //   data.filter = getFilterKey;
  //   data.searchText = '';
  //   data.sort = getListInput.sort === "1" ? "-1" :"1";
  //   getMeetingLists(data);
  // };

  const searchMeeting = _.debounce(async (search: any) => {
    let data: any = {};
    data.offset = 0;
    data.limit = getListInput.limit;
    data.filter = getListInput.filter;
    data.searchText = search;
    data.sort = getListInput.sort;
   getMeetingLists(data);
  },1000);

  const searchMeetingList = (e: any) => {
    //  history.push("/meeting");
    let searchName = e.target.value;
    if (searchName !== "") {
      setSearchKey(searchName);
      searchMeeting(searchName);
    }
    else {
      if (searchName === "") {
        setSearchKey('');
        searchMeeting('');
      }
    }
  }; 

  useEffect(() => {
    if(navigator.userAgent.indexOf("Safari") !== -1 || navigator.userAgent.indexOf("Firefox") !== -1)
    {
      enablePermissionSafari('calls');
    }
    else{
      enablePermission('calls');
    }
 }, []);


 const navigateToRecordedPage=()=>{
  // storeWindowState('recordedMeeting')
  selectMeetingFilterKey("Recording")
  storeWindowState('mainPage')//
}

const navigateToMeetingPage =()=>{
  storeWindowState('mainPage')
}

const navigateToPlayList =()=>{
  // console.log("navigateToPlayList")
  // storeWindowState('playList')
  // selectMeetingFilterKey("playList")
//  console.log("currentWindowState>>>>",currentWindowState)

}

const openPlaylistModal = () =>{
  setTitle('');
  setDescription('');
  setPlaylistModal(true)
}
const closePlaylistModal = () =>{
  setPlaylistModal(false)
}

const openPlayList =()=>{
  let loggedUserDetails: UserDetails =
  store.getState().loginReducer.userdetails || [];
  let data: any = {
    playlist_id:null,
    playlist_name:title,
    playlist_desc:description,
    clip_record_id:[]

    // id: recordDetailPage.v_id,
    // meeting_id: recordDetailPage.meeting_id,
    // title: title,
    // description: description,
    // startPoint: timeStringToSeconds(formatTime(trimStart)),
    // endpoint: timeStringToSeconds(formatTime(trimEnd)),
    // inputStream: recordDetailPage.record_url,
    // ext: loggedUserDetails.ext,
    // duration: calculateDurationInSec(),
    // size: recordDetailPage.record_size
  };

  // createClip(data);
  // closeModalClip();
  createPlayList(data);
  closePlaylistModal();
  setTitle('');
  setDescription('');
  
  const update_data:any={
    title:title,
    description:description
  }

  store.dispatch({
    type: Types.UPDATE_PLAYLIST,
    payloads:update_data
  });

}


  
  // const filtermenu = (
  //   <Menu className={styles.meetingFilter} onClick={selectMeetingFilterKey}>
  //     <Menu.Item key={"All"} className={ getFilterKey === "All"? styles.filterSelected : ""}>All</Menu.Item>
  //     <Menu.Item key={"Upcoming Meetings"} className={getFilterKey === "Upcoming" ? styles.filterSelected : ""}>
  //       Upcoming Meetings</Menu.Item>
  //     <Menu.Item key={"Previous Meetings"} className={getFilterKey === "Previous" ? styles.filterSelected : ""}
  //     >Previous Meetings</Menu.Item>
  //     <Menu.Item key={"Recurrence Meetings"} className={getFilterKey === "Recurrence" ? styles.filterSelected : ""}
  //     >Recurrence Meetings</Menu.Item>
  //   </Menu>
  // );

 

  return (
    <>
      <div className={styles.leftsidebar}>
        <div className={styles.top}>
          <CreateDropDown></CreateDropDown>
        </div>
        {/* {(!chat_reducer.notifyPermission || !chat_reducer.audioPermission || !chat_reducer.videoPermission) && <div className={styles.notificationtop}><NotificationBottom /></div>} */}
         {(contactList?.jenkinMessage ) && <div className={styles.notificationtop}><NotificationBottom  /></div>}
        <div className={styles.toptapnavfilter}>
            <div className={styles.listmettingtap}>
                  <ul>
                      <li className={getFilterKeyDisplay === "Upcoming" ? styles.active : ""}  onClick={()=>selectMeetingFilterKey("Upcoming")}>
                      <Link >Upcoming</Link>
                      </li>
                      <li className={getFilterKeyDisplay === "Previous" ? styles.active : ""} onClick={()=>selectMeetingFilterKey("Previous")}>
                      <Link >Previous</Link>
                      </li>
                      <li className={getFilterKeyDisplay === "Recurrence" ? styles.active : ""} onClick={()=>selectMeetingFilterKey("Recurrence")}>
                      <Link>Recurring</Link>
                      </li>
                  </ul>
            </div>
        </div>
        <Modal
              centered
              visible={playlistModal}
              title = "Create Playlist"
              onCancel={closePlaylistModal}
              className="cv modallnewst"
              onOk={openPlayList}> 
              
              <div>
              <div className={styles.ppmetricssectionn}>
                <div >
                 <div className={styles.modalrow}>
                    <label>
                       Title Name <span>*</span>
                    </label>
                    <input type="text" 
                   value={title}
                   onChange={(e)=>setTitle(e.target.value)}
                   placeholder="Enter title name" ></input>
                  </div>
                  <div className={styles.modalrow}>
                    <label>
                       Description 
                     </label>
                     <textarea 
                   value={description}
                   onChange={(e)=>setDescription(e.target.value)}
                   placeholder="Enter description"></textarea>
                   </div>
                </div>
              </div>
              </div>
        </Modal>

        <div className={styles.middlelayertop}>
          <div className={styles.searchBox}>
            <URInput placeHolder="Search" className="leftbarsearch" onChange={searchMeetingList} value={getSearchKey}/>
          </div>
          {/* <span className={`icon__Filter ${styles.unreadFilter} `} 
          onClick={unreadmeetingList}
          >

          </span> */}
        </div>
        {currentWindowState !== 'playList' &&
        <div className={styles.rightbartop}>
          {currentWindowState === "recordedMeeting" ? (
          <div className={styles.lefts} onClick={navigateToMeetingPage}>
          <h3><img src={recordVid} alt="" /> Recorded Videos</h3>
        </div>

          ): ( <div className={styles.lefts} onClick={navigateToRecordedPage}>
            <h3><img src={recordVid} alt="" /> Recorded Videos
            </h3>
         
          
       
          </div>)}
          {/* <span onClick={openPlaylistModal} className={styles.playlistspan} > */}
            {/* <span 
          onClick={navigateToPlayList}
           style={{display:'flex'}}>
          <div className={styles.playlistsvgcon}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M14.0384 5.91633L9.20039 3.12749L4.3624 0.338652C3.97256 0.118743 3.56274 0.00878906 3.1629 0.00878906C1.90343 0.00878906 0.753906 1.01837 0.753906 2.41779V13.5831C0.753906 14.9925 1.90343 15.9921 3.1629 15.9921C3.56274 15.9921 3.97256 15.8922 4.3624 15.6623L9.20039 12.8734L14.0384 10.0846C15.6477 9.15498 15.6477 6.83594 14.0384 5.91633Z" fill="#575CFF"/>
            </svg>
          </div>
            Create Playlist
          </span> */}
            
           

          {/* <div className={styles.rights}>
            <span>{recCount}</span>
          </div> */}
        </div>}
        {/* <div className="searchEmpty">
          <img src={EmptyImage} alt="" />
          <p>No Reesult Found</p>
        </div> */}
        {/* <div className={styles.filterSec}>
          <Dropdown overlay={filtermenu} placement="bottomLeft" trigger={['click']}>
            <div className={styles.filterSel}>{getFilterKeyDisplay}<span className="icon_downarrow2"></span></div>
          </Dropdown>
         {getFilterKeyDisplay === "All" &&  <div className={styles.sortingSec}>
            <span className={getListInput.sort === "-1" ? "icon_sortup" : "icon_sortdown"} onClick={sortMeeting}></span>
          </div>}
        </div> */}
          
          {currentWindowState === 'playList' &&
        <div className={styles.rightbartop}>
           <div className={styles.lefts} onClick={navigateToRecordedPage}>
            <span> Back Playlist </span>
           </div>
         
          <span 
          onClick={openPlaylistModal}
           style={{display:'flex'}}> + Create Playlist</span>
        </div>
        }
            {currentWindowState === 'playList' ?
        <PlayLists/> :   <MeetingsLists />
        } 

      </div>


    </>
  );
};

